import api from 'services/api';

const permissionPresetService = {
  // Listar todos os presets
  getAll: async () => {
    const response = await api.get('/permission-presets');
    return response.data;
  },

  // Buscar preset por ID
  getById: async (id) => {
    const response = await api.get(`/permission-presets/${id}`);
    return response.data;
  },

  // Criar novo preset
  create: async (presetData) => {
    const response = await api.post('/permission-presets', presetData);
    return response.data;
  },

  // Atualizar preset
  update: async (id, presetData) => {
    const response = await api.put(`/permission-presets/${id}`, presetData);
    return response.data;
  },

  // Excluir preset
  delete: async (id) => {
    const response = await api.delete(`/permission-presets/${id}`);
    return response.data;
  },

  // Atualizar permissões do preset
  updatePermissions: async (id, permissions) => {
    const response = await api.put(`/permission-presets/${id}/permissions`, {
      permissions: permissions
    });
    return response.data;
  },

  // Aplicar preset a um usuário
  applyToUser: async (presetId, userId) => {
    const response = await api.post(`/permission-presets/${presetId}/apply`, {
      user_id: userId
    });
    return response.data;
  }
};

export default permissionPresetService;

